module.exports = __webpack_public_path__ + "media/images/flags/1x1/cym-7bc9d67b7e3ece8db8d14ae3c0644595.svg";